/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Mitarbeiter API
 * Employee master data: contact details, organisation, keys, parking and vehicles.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccessItem,
  AccessItemInput
} from '../models';

import { customFetch } from '../../fetcher.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListAccessItemsUrl = () => {




  return `/api/access-items`
}

/**
 * @summary All keys, transponders and door permissions, including unassigned ones.
 */
export const listAccessItems = async ( options?: Parameters<typeof customFetch>[1]): Promise<AccessItem[]> => {

  return customFetch<AccessItem[]>(getListAccessItemsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAccessItemsQueryKey = () => {
    return [
    `/api/access-items`
    ] as const;
    }


export const getListAccessItemsQueryOptions = <TData = Awaited<ReturnType<typeof listAccessItems>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccessItemsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccessItems>>> = ({ signal }) => listAccessItems({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccessItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAccessItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listAccessItems>>>
export type ListAccessItemsQueryError = unknown


export function useListAccessItems<TData = Awaited<ReturnType<typeof listAccessItems>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccessItems>>,
          TError,
          Awaited<ReturnType<typeof listAccessItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAccessItems<TData = Awaited<ReturnType<typeof listAccessItems>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccessItems>>,
          TError,
          Awaited<ReturnType<typeof listAccessItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAccessItems<TData = Awaited<ReturnType<typeof listAccessItems>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary All keys, transponders and door permissions, including unassigned ones.
 */

export function useListAccessItems<TData = Awaited<ReturnType<typeof listAccessItems>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccessItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAccessItemsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateAccessItemUrl = () => {




  return `/api/access-items`
}

export const createAccessItem = async (accessItemInput: AccessItemInput, options?: Parameters<typeof customFetch>[1]): Promise<AccessItem> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AccessItem>(getCreateAccessItemUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(accessItemInput)
  }
);}





export const getCreateAccessItemMutationKey = () => ['createAccessItem'] as const;

export const getCreateAccessItemMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccessItem>>, TError,CreateAccessItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAccessItem>>, TError,CreateAccessItemMutationVariables, TContext> => {

const mutationKey = getCreateAccessItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccessItem>>, CreateAccessItemMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createAccessItem(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAccessItemMutationResult = NonNullable<Awaited<ReturnType<typeof createAccessItem>>>
    export type CreateAccessItemMutationBody = AccessItemInput
    export type CreateAccessItemMutationError = unknown
    export type CreateAccessItemMutationVariables = {data: AccessItemInput}

    export const useCreateAccessItem = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccessItem>>, TError,CreateAccessItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAccessItem>>,
        TError,
        CreateAccessItemMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAccessItemMutationOptions(options), queryClient);
    }
    export const getUpdateAccessItemUrl = (id: number,) => {




  return `/api/access-items/${id}`
}

export const updateAccessItem = async (id: number,
    accessItemInput: AccessItemInput, options?: Parameters<typeof customFetch>[1]): Promise<AccessItem> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AccessItem>(getUpdateAccessItemUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(accessItemInput)
  }
);}





export const getUpdateAccessItemMutationKey = () => ['updateAccessItem'] as const;

export const getUpdateAccessItemMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccessItem>>, TError,UpdateAccessItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAccessItem>>, TError,UpdateAccessItemMutationVariables, TContext> => {

const mutationKey = getUpdateAccessItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccessItem>>, UpdateAccessItemMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateAccessItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccessItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccessItem>>>
    export type UpdateAccessItemMutationBody = AccessItemInput
    export type UpdateAccessItemMutationError = unknown
    export type UpdateAccessItemMutationVariables = {id: number;data: AccessItemInput}

    export const useUpdateAccessItem = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccessItem>>, TError,UpdateAccessItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAccessItem>>,
        TError,
        UpdateAccessItemMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAccessItemMutationOptions(options), queryClient);
    }
    export const getDeleteAccessItemUrl = (id: number,) => {




  return `/api/access-items/${id}`
}

export const deleteAccessItem = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteAccessItemUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAccessItemMutationKey = () => ['deleteAccessItem'] as const;

export const getDeleteAccessItemMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccessItem>>, TError,DeleteAccessItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccessItem>>, TError,DeleteAccessItemMutationVariables, TContext> => {

const mutationKey = getDeleteAccessItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccessItem>>, DeleteAccessItemMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteAccessItem(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccessItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccessItem>>>

    export type DeleteAccessItemMutationError = unknown
    export type DeleteAccessItemMutationVariables = {id: number}

    export const useDeleteAccessItem = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccessItem>>, TError,DeleteAccessItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccessItem>>,
        TError,
        DeleteAccessItemMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAccessItemMutationOptions(options), queryClient);
    }
